module.exports = __webpack_public_path__ + "static/Bucees_pin_hover-7444edb9dee90c1320522fa048f48fa5.png";